module.exports = __webpack_public_path__ + "img/143.f0b2efb4.jpg";